// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__sipBh","modal":"Modal_modal__U065X"};